var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "236px",
    height: "188px",
    viewBox: "0 0 236 188",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "40C20016-AEA1-4EB7-84EE-0B53D69ED4B6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.8182915,48.0344599 C28.9253074,51.9190689 22.61347,51.9190689 18.7211378,48.0344599 C14.8281535,44.1492002 14.8281535,37.8498869 18.7211378,33.9652778 L32.8182915,48.0344599 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-14.7%",
    y: "-14.7%",
    width: "129.4%",
    height: "129.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -3,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.470588235   0 0 0 0 0.537254902   0 0 0 0 0.6  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M31.2457484,36.7472553 C28.4805034,33.9869819 28.4805034,29.5116499 31.2457484,26.7520237 L44.2671726,13.7570577 C44.8197028,13.2056501 45.715943,13.2056501 46.2691218,13.7570577 L54.2827549,21.7550551 C54.8352851,22.3064626 54.8352851,23.2008819 54.2827549,23.7529365 L41.2619792,36.7472553 C38.4960857,39.5075287 34.0116418,39.5075287 31.2457484,36.7472553 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-9.8%",
    y: "-9.8%",
    width: "119.6%",
    height: "119.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -3,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.470588235   0 0 0 0 0.537254902   0 0 0 0 0.6  0 0 0 0.5 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Messages---Empty-state",
    transform: "translate(-619.000000, -262.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(608.000000, 240.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.747266,211.172208 C228.261731,211.172208 246.237,168.721503 246.237,108.974528 C246.237,49.2275523 116.896562,21 64.2732454,21 C11.6499287,21 10.6949107,93.2756575 24.5621277,123.726546 C38.4293446,154.177435 67.2328007,211.172208 147.747266,211.172208 Z",
    id: "Oval",
    fill: "#F8F9FC",
    transform: "translate(131.618500, 116.086104) rotate(-11.000000) translate(-131.618500, -116.086104) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-39",
    transform: "translate(58.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-30",
    transform: "translate(0.000000, 29.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EAEDF1",
    points: "48 24.7790042 48 62 35.6113106 57.5792048 32.3076923 38.9686583 35.6113106 20.358209"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C5CCD7",
    points: "36 20.358209 36 57.5792048 23.4601241 62 21.2307692 43.3895507 23.4601241 24.7790042"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#EAEDF1",
    points: "23.0769231 24.7790042 23.0769231 62 10.6882336 57.5792048 7.38461538 38.9686583 10.6882336 20.358209"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#C5CCD7",
    points: "13.8461538 20.358209 13.8461538 57.5792048 0 62 0 24.7790042"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2413793,57.5867501 L0,62 L0,24.8425321 L13.2413793,20.4292821 L13.2413793,20.3856362 L24.8275862,24.8425321 L24.8275862,24.834685 L36.293,20.475209 L36.2937396,20.358209 L48,24.8425321 L48,62 L36.413,57.561209 L36.4137931,57.5867501 L24.8275862,61.9921529 L24.8275862,62 L13.2413793,57.5431041 L13.2413793,57.5867501 Z",
    id: "Combined-Shape",
    stroke: "#788999",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,-6.84029947e-15 C23.8627481,-6.84029947e-15 28.6153846,5.30993169 28.6153846,11.8599177 C28.6153846,21.3565717 19.0194846,30.1518482 19.0194846,30.1518482 C18.4588278,30.6658019 17.5411722,30.6658019 16.9805154,30.1518482 C16.9805154,30.1518482 7.38461538,21.3565717 7.38461538,11.8599177 C7.38461538,5.30993169 12.1372519,-6.84029947e-15 18,-6.84029947e-15 Z M18,5.08955224 C15.2984351,5.08955224 13.1005917,7.37278047 13.1005917,10.1791045 C13.1005917,12.9854285 15.2984351,15.2686567 18,15.2686567 C20.7015649,15.2686567 22.8994083,12.9854285 22.8994083,10.1791045 C22.8994083,7.37278047 20.7015649,5.08955224 18,5.08955224 Z",
    id: "Combined-Shape",
    fill: "#788999"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-33",
    transform: "translate(0.000000, 103.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7573444,54.5397518 C14.9173716,51.3041629 11.8083627,47.5953536 10.5154903,43.5154865 C2.36952035,40.0132136 0,31.8172139 0,22.6066652 C0,10.1415103 6.81245903,0 18.737897,0 L46.262103,0 C58.1871042,0 65,10.1415103 65,22.6066652 C65,35.0718201 58.187541,45.2128881 46.262103,45.2128881 L24.9183514,45.2128881 C24.7349033,47.0783493 24.8091561,49.0203218 25.1389259,50.9883878 L26.1282354,56.8961238 C26.2645111,57.7098859 25.3765349,58.2958831 24.6964665,57.8412378 L19.7573444,54.5397518 Z",
    id: "Path",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#E7EAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,21.8380256 C65,9.79669313 55.5054488,0 43.8342168,0 L16.8967246,0 C13.8586905,0 10.9711261,0.669034121 8.35714286,1.86355481 C9.48181821,19.9420017 24.8476792,34.0634921 43.1622329,34.0634921 L61.3635069,34.0634921 C63.6581695,30.5726378 65,26.3636185 65,21.8380256 Z",
    id: "Path",
    fillOpacity: 0.3,
    fill: "#788999"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.8343837,138.23579 C96.618977,134.90519 96.8478374,131.635913 96.5164873,128.515775 L66.0775535,128.515775 C48.9602864,128.515775 41.2675065,115.112428 41.0068046,98.2352295 C40.7411275,81.0577911 48.2433562,67 65.6039119,67 L104.951984,67 C122.10557,67 129.78641,80.4749729 129.987409,97.3884751 C130.138656,110.081942 129.100739,121.413537 117.21741,126.219334 C114.659149,133.857785 107.381885,139.303309 101.713111,142.531376 L95.8731905,145.856579 C95.0691939,146.314788 94.0985272,145.605399 94.3084817,144.71351 L95.8343837,138.23579 Z",
    id: "Path",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#F8F9FC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1331315,105.902067 C61.902526,88.5889211 74.1358461,74.4209678 89.2046638,74.4209678 L120,74.4209678 C115.064869,69.1946376 108.44295,66 101.228539,66 L67.0747399,66 C52.0059221,66 39.7726021,80.1684477 40.0032076,97.4810993 C40.2299265,114.490653 52.6282115,128 67.4858568,128 L70.8240227,128 C65.5909187,122.465133 62.2501617,114.649372 62.1331315,105.902067 Z",
    id: "Path",
    fillOpacity: 0.1,
    fill: "#788999",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(113.000000, 117.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#E7EAF3",
    x: 0,
    y: 0,
    width: 24.2857143,
    height: 43,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,0 L22.2857143,0 C23.3902838,-2.16501571e-15 24.2857143,0.8954305 24.2857143,2 L24.2857143,5.97222222 L24.2857143,5.97222222 L0,5.97222222 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 Z",
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fillOpacity: 0.5,
    fill: "#788999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,35.8333333 L22.2857143,35.8333333 C23.3902838,35.8333333 24.2857143,36.7287638 24.2857143,37.8333333 L24.2857143,43 L24.2857143,43 L0,43 L0,37.8333333 C-1.3527075e-16,36.7287638 0.8954305,35.8333333 2,35.8333333 Z",
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fillOpacity: 0.5,
    fill: "#788999",
    transform: "translate(12.142857, 39.416667) scale(1, -1) translate(-12.142857, -39.416667) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#788999",
    cx: 12.1428571,
    cy: 39.4166667,
    rx: 1.21428571,
    ry: 1.19444444
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#F8F9FC",
    x: 10.9285714,
    y: 13.1388889,
    width: 23.0714286,
    height: 15.5277778,
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5914766,19.1111111 L31.1121887,19.1111111 C31.6644735,19.1111111 32.1121887,19.5588264 32.1121887,20.1111111 C32.1121887,20.4177088 31.9715411,20.7073624 31.7305999,20.8969658 L22.5091724,28.1535663 C22.131084,28.4510947 21.5947195,28.437213 21.2325276,28.1205253 L12.9332429,20.8639248 C12.5174754,20.5003924 12.4751304,19.868645 12.8386628,19.4528775 C13.0285555,19.2356996 13.3029884,19.1111111 13.5914766,19.1111111 Z",
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#F8F9FC",
    transform: "translate(22.464286, 23.888889) scale(1, -1) translate(-22.464286, -23.888889) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5914766,13.1388889 L31.1121887,13.1388889 C31.6644735,13.1388889 32.1121887,13.5866041 32.1121887,14.1388889 C32.1121887,14.4454866 31.9715411,14.7351402 31.7305999,14.9247436 L22.5091724,22.181344 C22.131084,22.4788724 21.5947195,22.4649907 21.2325276,22.148303 L12.9332429,14.8917026 C12.5174754,14.5281702 12.4751304,13.8964228 12.8386628,13.4806553 C13.0285555,13.2634774 13.3029884,13.1388889 13.5914766,13.1388889 Z",
    id: "Rectangle",
    stroke: "#788999",
    strokeWidth: 2,
    fill: "#F8F9FC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-36",
    transform: "translate(49.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(8.508446, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8456001,1.40993276 L25.3223257,13.8612365 C26.1041704,14.6414881 26.1054618,15.9078174 25.3252102,16.6896621 C25.3242633,16.690611 25.3233154,16.6915588 25.3223666,16.6925058 L16.7208121,25.2770304 C15.9401013,26.0561955 14.6759633,26.0562137 13.89523,25.2770712 L1.41850441,12.8257675 C0.636659712,12.0455158 0.635368296,10.7791865 1.41561995,9.99734183 C1.41656685,9.996393 1.4175147,9.99544512 1.4184635,9.9944982 L10.020018,1.40997359 C10.8007288,0.630808498 12.0648668,0.630790232 12.8456001,1.40993276 Z",
    id: "Path",
    stroke: "#788999",
    strokeWidth: 2,
    fillRule: "nonzero",
    transform: "translate(13.370415, 13.343502) scale(-1, -1) translate(-13.370415, -13.343502) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17.0168919,
    y1: 6.06522817,
    x2: 6.07746139,
    y2: 16.9826389,
    id: "Path",
    fill: "#D7E9FF",
    fillRule: "nonzero",
    transform: "translate(11.547177, 11.523934) scale(-1, -1) translate(-11.547177, -11.523934) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5.46971525,
    y1: 5.45870536,
    x2: 24.9175917,
    y2: 24.8674355,
    id: "Line-13",
    stroke: "#788999",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.4990197,
    y1: 10.538334,
    x2: 9.49603342,
    y2: 22.5171596,
    id: "Line-13-Copy",
    stroke: "#788999",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-34",
    transform: "translate(41.326737, 32.752232)",
    stroke: "#788999",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.845955,1.4099443 L25.3223373,13.8612129 C26.1041723,14.6414743 26.1054481,15.9078036 25.3251868,16.6896386 C25.3242379,16.6905894 25.3232881,16.6915393 25.3223373,16.6924881 L16.7204513,25.2770596 C15.9397299,26.0562095 14.6755964,26.0562095 13.8948751,25.2770596 L1.41849286,12.8257909 C0.636657802,12.0455295 0.635382035,10.7792002 1.41564335,9.99736518 C1.41659223,9.99641438 1.41754207,9.99546455 1.41849287,9.99451566 L10.0203789,1.4099443 C10.8011002,0.630794439 12.0652337,0.630794439 12.845955,1.4099443 Z",
    id: "Path",
    fillRule: "nonzero",
    transform: "translate(13.370415, 13.343502) scale(-1, -1) translate(-13.370415, -13.343502) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2.43098456,
    y1: 2.42609127,
    x2: 21.2711149,
    y2: 21.2282986,
    id: "Line-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.4990197,
    y1: 10.538334,
    x2: 9.49603342,
    y2: 22.5171596,
    id: "Line-13"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.6370506,
    y1: 5.68615141,
    x2: 4.63406431,
    y2: 17.6649771,
    id: "Line-13"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: 35,
    x2: 21,
    y2: 46,
    id: "Line-14",
    stroke: "#788999",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    strokeLinejoin: "round",
    fillRule: "nonzero",
    transform: "translate(24.309846, 42.456597) scale(-1, -1) translate(-24.309846, -42.456597) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#E7EAF3",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#788999",
    strokeWidth: 2,
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.4319288,49.8521825 C18.7819037,49.8521825 18.1712379,49.5990546 17.712841,49.1382424 C17.2532513,48.6778286 17,48.0659368 17,47.4145809 C17,46.7632251 17.2532513,46.1509347 17.712841,45.6905209 C18.6300324,44.7700921 20.2326325,44.7696935 21.1514142,45.6901223 C22.0988207,46.6412454 22.0988207,48.1879166 21.1514142,49.138641 C20.6918245,49.5990546 20.0811587,49.8521825 19.4319288,49.8521825 L19.4319288,49.8521825 Z",
    id: "Path",
    fill: "#788999",
    fillRule: "nonzero",
    transform: "translate(19.430985, 47.426091) scale(-1, -1) translate(-19.430985, -47.426091) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero",
    transform: "translate(41.934484, 26.080481) scale(-1, -1) translate(-41.934484, -26.080481) "
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#E7EAF3",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#788999",
    strokeWidth: 2,
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 25.1454965,
    y1: 5.68615141,
    x2: 13.1425103,
    y2: 17.6649771,
    id: "Line-13-Copy-2",
    stroke: "#788999",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,47.0146799 C8.99595005,51.0384132 12.2545442,54.2970074 16.2782776,54.2929574 C20.3020109,54.2888999 23.5671775,51.0237334 23.5712313,47",
    id: "Path",
    stroke: "#AFB9C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(16.285616, 50.646479) rotate(45.000000) translate(-16.285616, -50.646479) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.23845566,46.1091872 C1.23103075,53.4860317 7.20512008,59.460121 14.5819646,59.4526961 C21.9588091,59.4452573 27.9449478,53.4591186 27.9523796,46.0822741",
    id: "Path",
    stroke: "#AFB9C6",
    strokeWidth: 2,
    strokeLinecap: "round",
    transform: "translate(14.595418, 52.767485) rotate(45.000000) translate(-14.595418, -52.767485) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-31",
    transform: "translate(118.540133, 85.231481) rotate(9.000000) translate(-118.540133, -85.231481) translate(79.540133, 49.231481)",
    fillRule: "nonzero",
    stroke: "#788999",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(38.930652, 35.876380) rotate(-3.000000) translate(-38.930652, -35.876380) translate(2.430652, 2.376380)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(42.680165, 27.065824) rotate(-8.000000) translate(-42.680165, -27.065824) translate(16.180165, 3.565824)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#B8C1C9",
    transform: "translate(31.576476, 25.388649) rotate(13.000000) translate(-31.576476, -25.388649) ",
    points: "14.4837362 26.5285434 16.7439721 43.47941 48.6692164 7.29788795"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#97A5B1",
    transform: "translate(32.677629, 25.642870) rotate(13.000000) translate(-32.677629, -25.642870) ",
    points: "48.6402515 7.55210918 20.5346341 30.9383026 16.7150073 43.7336313"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E7EAF3",
    transform: "translate(34.952341, 24.279918) rotate(13.000000) translate(-34.952341, -24.279918) ",
    points: "39.3645891 40.5309603 49.0051498 8.02887559 20.8995324 31.415069"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#E7EAF3",
    transform: "translate(26.608918, 15.452381) rotate(13.000000) translate(-26.608918, -15.452381) ",
    points: "2.44076288 22.1378253 16.9090212 24.978997 50.7770722 5.92576446"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeWidth: 1.53999996,
    transform: "translate(11.584293, 45.066197) rotate(12.000000) translate(-11.584293, -45.066197) ",
    points: "2.41754332 54.111134 19.9797222 36.0212606 20.7510437 37.0954706"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeWidth: 1.53999996,
    transform: "translate(32.927890, 55.882581) rotate(12.000000) translate(-32.927890, -55.882581) ",
    points: "24.3696842 64.9251855 24.3696842 64.9251855 40.3656645 46.8399762 41.4860949 47.3397538"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    strokeWidth: 1.53999996,
    transform: "translate(18.292573, 54.079427) rotate(12.000000) translate(-18.292573, -54.079427) ",
    points: "10.958954 61.3151096 10.958954 61.3151096 25.6261911 47.5578506 24.8294883 46.8437446"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/notFound.44c164084238f16705301d3b21615672.svg";
export { ForwardRef as ReactComponent };